var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLighting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_46_6)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_46_6",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_46_6",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_46_6",
    width: 64,
    height: 64,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAA5ZJREFUeJztmb2PDVEYxp/je2kkKIhKrGSJRkQnQWIlCLJCUEpEpcAfsKIlGo2CUCl8JFalkggNomGjID4SrIJEfC/Z3Z/i7Ma1e86ZmXvnzHEn91fu3Dnv8z47eeY9Z6QOHf4rgJXAVmBBai2VA5zmL5+BDak1VQZwlKk8Tq2rEsYf+RGHAaOptUUH6AE+OZoHILW+qAALgOe+5mttADATuB1qvu4GnMtqvrYGAMfyNF9LA4AtuBO//gYAq7ADjosftTaAcOIP4R6EohswLXYBySa+pKuSljsuD0vaJeltFVomU4kBks5K2uj4O5IOGmMeVKSjeggnfn/D7/bULgMIJ/41wDT8tl4GEJ7xHwHzJv0+iQFRMgB7mHFT0nzH5feSdhpjvseoXZTSDSBH4htjkiS+ixhPQCfxPfRn3NveIUiBxPfc374GEJ7xHwJdOdZwGtAkw8AAsKiK5hcCLzxC3gFLcq5TpgET3Miq21IIArMkXZe0zHH5p+zrbijncjEOQDdHWPMvwHmP82PA3oJrrRi/r0yexOrdd44/QTDxA2ueLNGEEaA3q2YwmQNCt8pOetMdl69I2meMaSrBgW5Jqz1rT+aIpPWea8eNMWea0RCE7Bl/bulF3Tp2B56Wi7GKZp3qLI1SeKqONcA3j467wOwYRUPn+D+AdaUXdetYDLzx6HhFrHc//nP8MWB/lKJTNXQB9z06vgCri645I2fhY5IOey7fkzQC7MlYZlTSoDHmWQF9jRqMpEuSXE/aqGzwlv/aA3opcI6fwRhwskkd/YF1j5bdd2PhpyU132hCd0ENe/En/vlYvU8UHy7ZAIC+AvXX4vloAtzBjuNNk2cvcKuVAh7yDDnCbqQGJLl2ky8l7TbG/G5FSJ4QPCQ7MfZKmtNKsSJgt9ADkly7yS+SdhhjPlalp2k8j27wjQEY4LLn3lFge1X6W6ZJA04E8iNe4segqAGkmPFjUsQA7Iz/3XNPlBm/qo+jmQCLZUPPtZt8LanPGPOr7Lr/hQHYxL8hybWb/Cqb+B9i1E5uAHbGvyD3jD8m6UCUGb8qsjKAOiW+i5AB1C3xXfgMIEHiu0iVAUkSPwme/7Bvd/cZWJVac6l4GnXRXjN+XgoY0P6J7yJn8/VIfBc5mq8s8ZOQ0fwrqviGn5JA802d47cd2HSfzAj2A2v9AQYdBtQz8V0Am8Yf9wlOpdZUOdivytuAntRaOnT4lz+RH0XeiFIn5wAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighting);
export default __webpack_public_path__ + "static/media/lighting.ad2a1fba263371418235a64d270d7e6d.svg";
export { ForwardRef as ReactComponent };